export default "__VITE_ASSET__D_JvM9QJ__"